module.exports = __webpack_public_path__ + "static/media/foot-travel-myth-badge_2x.4ffa4fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/foot-travel-myth-badge_2x.png
// module id = 609
// module chunks = 0